export const PROPERTY_AGENCIES = [
  {
    id: 1,
    name: "PropNex Realty Pte Ltd",
    numberOfAgents: 12636,
  },
  {
    id: 2,
    name: "ERA Realty Network Pte Ltd",
    numberOfAgents: 8648,
  },
  {
    id: 3,
    name: "Huttons Asia Pte Ltd",
    numberOfAgents: 5699,
  },
  {
    id: 4,
    name: "OrangeTee & Tie Pte Ltd",
    numberOfAgents: 2756,
  },
  {
    id: 5,
    name: "SRI Pte Ltd",
    numberOfAgents: 1493,
  },
  {
    id: 6,
    name: "C&H Properties Pte Ltd",
    numberOfAgents: 202,
  },
  {
    id: 7,
    name: "SN Real Estate Pte Ltd",
    numberOfAgents: 150,
  },
  {
    id: 8,
    name: "KF Property Network Pte Ltd",
    numberOfAgents: 145,
  },
  {
    id: 9,
    name: "Century 21 Pte Ltd",
    numberOfAgents: 134,
  },
  {
    id: 10,
    name: "CBRE Pte Ltd",
    numberOfAgents: 99,
  },
];

export const PROPERTY_AGENCIES_MAP = PROPERTY_AGENCIES.reduce(
  (acc, agency) => {
    acc[agency.id] = agency;
    return acc;
  },
  {} as Record<number, (typeof PROPERTY_AGENCIES)[number]>
);

export const PROPERTY_AGENCY_NAMES = PROPERTY_AGENCIES.map(
  (agency) => agency.name
);

export const findPropertyAgencyByName = (name: string) => {
  const normalizedSearchName = name
    .toLowerCase()
    .replace(/\s*ltd\s*$/i, "")
    .trim();

  return PROPERTY_AGENCIES.find((agency) => {
    const normalizedAgencyName = agency.name
      .toLowerCase()
      .replace(/\s*ltd\s*$/i, "")
      .trim();

    return normalizedSearchName.includes(normalizedAgencyName);
  });
};
